export default __webpack_public_path__ + "static/media/storageUnit1-afterB-2048w.602dd4f1.webp";